
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class WIPMovementGrid extends Serenity.EntityGrid<WIPMovementRow, any> {
        protected getColumnsKey() { return 'Production.WIPMovement'; }
        protected getDialogType() { return WIPMovementDialog; }
        protected getIdProperty() { return WIPMovementRow.idProperty; }
        protected getInsertPermission() { return WIPMovementRow.insertPermission; }
        protected getLocalTextPrefix() { return WIPMovementRow.localTextPrefix; }
        protected getService() { return WIPMovementService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}